import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled } from '@ori-ui/mui';
import { useTranslation } from 'react-i18next';
import { LocalizationKeys } from '../../../models/localizationKeys';
import { jsx as _jsx } from "react/jsx-runtime";
var LoginOriSalesRoot = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    backgroundColor: theme.palette.common.white,
    height: '100vh',
    padding: theme.spacing(1, 2)
  }, theme.breakpoints.down('md'), {
    width: 'initial'
  });
});
var LoginOriSalesIframe = styled('iframe')({
  border: 'none',
  height: 500,
  width: '100%'
});
export var LoginOriSales = function LoginOriSales() {
  var _useTranslation = useTranslation(),
      _useTranslation2 = _slicedToArray(_useTranslation, 1),
      t = _useTranslation2[0];

  return /*#__PURE__*/_jsx(LoginOriSalesRoot, {
    children: /*#__PURE__*/_jsx(LoginOriSalesIframe, {
      title: t(LocalizationKeys.orisalesLogin.id),
      src: "/system/UI/LoginPopup/NewLayoutLoginStandalone"
    })
  });
};
export default LoginOriSales;